import { Navigate, Route, Routes, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "./App.css";
import Auth from "../Auth/Auth";
import Platform from "../Platform/Platform";
import Subscription from "../Platform/Subscription/Subscription";
import { useEffect, useState } from "react";
import {
  AUTH_LOGIN_LINK,
  AUTH_MAIN_LINK,
  AUTH_RESET_PASSWORD_TYPE,
  AUTH_SIGNUP_WITH_SHOP_LINK,
  CONTROLLERS_MAIN_LINK,
  CONTROLLERS_NO_SHOP_LINK,
  DEMO_SUBSCRIPTION_ID,
  NOTIFY_BLOCKED,
  NOTIFY_REGISTRATION_TYPE,
  NOTIFY_REGISTRATION_WALK_THROUGH,
  NOTIFY_SUBSCRIPTION_TYPE,
  NOTIFY_TRIES_LEFT,
  PLATFORM_MAIN_LINK,
  PLATFORM_MAIN_LINKS,
} from "../../assets/utils/constants";
import NotificationLine from "../NotificationLine/NotificationLine";
import mainApi from "../../assets/api/MainApi";
import { UserContext } from "../../assets/contexts/userContext";
import moment from "moment-timezone";
import { filterLinksForUserRBAC, getDefaultLinkForUserRBAC, hasPermission, parsePermissions } from "../../assets/utils/utils";
import { PlatformLinksContext } from "../../assets/contexts/platformLinksContext";
import { PERMISSIONS, RBAC_SHOP_SETTINGS } from "../../assets/utils/permissions_rbac";


const Overlay = ({ onClick }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
        zIndex: 1 // Ensure it's above other content
      }}
      onClick={onClick}
    />
  );
};


const NOTIFY_INIT_VALUE = {
  [NOTIFY_SUBSCRIPTION_TYPE]: false,
  [NOTIFY_REGISTRATION_TYPE]: false,
  [NOTIFY_REGISTRATION_WALK_THROUGH]: false,
  [NOTIFY_BLOCKED]: false,
  [NOTIFY_TRIES_LEFT]: false,
}
function App() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation()
  const [user, setUser] = useState(undefined);
  const [preloader, setPreloader] = useState(true);
  const [isNotifyOpen, setIsNotifyOpen] = useState(NOTIFY_INIT_VALUE);

  const navigate = useNavigate()

  useEffect(() => {
    setPreloader(true)
    mainApi
      .getMe()
      .then((res) => {
        console.log(res);
        if (!res.default_shop) {
          navigate(`${PLATFORM_MAIN_LINK}/${CONTROLLERS_MAIN_LINK}/${CONTROLLERS_NO_SHOP_LINK}`)
        }
        setUser(res);

        if (res.register_stage === 1 && res.email_verified === true) {
          navigate(`${AUTH_SIGNUP_WITH_SHOP_LINK}`)

        }

      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setPreloader(false)
      })
  }, []);

  useEffect(() => {
    setIsNotifyOpen(prevValue => ({
      ...NOTIFY_INIT_VALUE,
    }))
    checkNotification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, location]);

  console.log({ isNotifyOpen })

  function checkNotification() {
    if (!user) return
    if (user.email_verified === false) {
      if (!hasPermission(parsePermissions(user), [RBAC_SHOP_SETTINGS[PERMISSIONS.MANAGE_BILLING]])) {
        closeNotification(NOTIFY_SUBSCRIPTION_TYPE)
        return
      }
      openNotification(NOTIFY_REGISTRATION_TYPE);
    } else {
      const subscriptions = user?.default_shop?.subscriptions
      const main_subscription = subscriptions?.main
      const isDemo = main_subscription && main_subscription._id && main_subscription._id === DEMO_SUBSCRIPTION_ID ? true : false
      if (isDemo) {
        openNotification(NOTIFY_SUBSCRIPTION_TYPE)
      } else {
        closeNotification(NOTIFY_SUBSCRIPTION_TYPE)
      }
      console.log({
        isDemo,
        is_blocked: main_subscription?.renewal?.is_blocked,
        tries_left: !main_subscription?.renewal?.is_blocked && main_subscription?.renewal?.tries_left,
      })
      if (main_subscription?.renewal?.is_blocked) {
        openNotification(NOTIFY_BLOCKED)
      }
      if (!main_subscription?.renewal?.is_blocked && main_subscription?.renewal?.tries_left) {
        openNotification(NOTIFY_TRIES_LEFT)
      }
    }



    // else {
    //   if (Object.values(user.subscriptions).length === 0)
    //     openNotification(NOTIFY_SUBSCRIPTION_TYPE);
    // }
  }

  function openNotification(type) {
    setIsNotifyOpen((prevVal) => ({ ...prevVal, [type]: true }));
  }

  function closeNotification(type) {
    setIsNotifyOpen((prevVal) => ({ ...prevVal, [type]: false }));
    if (type === NOTIFY_REGISTRATION_TYPE)
      setUser((prevVal) => ({ ...prevVal, registered: true }));
  }


  useEffect(() => {
    let walk_through = searchParams.get("walk-through")
    if (!walk_through) {
      closeNotification(NOTIFY_REGISTRATION_WALK_THROUGH)
      return
    } else {
      console.log(walk_through)
      if (walk_through) openNotification(NOTIFY_REGISTRATION_WALK_THROUGH)
      else {
        closeNotification(NOTIFY_REGISTRATION_WALK_THROUGH)
      }
    }
  }, [searchParams])

  const PLATFORM_LINKS_BY_USER_RBAC = user && user?.default_shop && user?.default_shop?.role ? filterLinksForUserRBAC(user?.default_shop?.role.permissions, PLATFORM_MAIN_LINKS) : null
  const DEFAULT_PLATFORM_LINK_BY_USER = PLATFORM_MAIN_LINK + getDefaultLinkForUserRBAC(PLATFORM_LINKS_BY_USER_RBAC)


  return (
    <div className="app">

      {!preloader ?
        <UserContext.Provider value={{ user, setUser }}>
          <PlatformLinksContext.Provider value={{
            links: PLATFORM_LINKS_BY_USER_RBAC,
            default_link: DEFAULT_PLATFORM_LINK_BY_USER,
          }}>

            {isNotifyOpen[NOTIFY_REGISTRATION_TYPE]
              //  || 
              // (isNotifyOpen.subscriptions && location.pathname !== `${PLATFORM_MAIN_LINK}/${SUBSCRIPTIONS_MAIN_LINK}/${SUBSCRIPTIONS_PLATFROM_LINK}`)
              ? <Overlay onClick={() => { }} /> : null}
            <NotificationLine
              isOpen={isNotifyOpen}
              onClose={closeNotification}
            />
            <Routes>
              {console.log(user)}
              <Route index element={user ? <Navigate replace to={DEFAULT_PLATFORM_LINK_BY_USER} /> : <Navigate replace to={AUTH_LOGIN_LINK} />}></Route>
              <Route path={`/${AUTH_MAIN_LINK}/*`} element={<Auth />}></Route>
              <Route path="/platform/*" element={
                user ?
                  user.register_stage === 1 && user.email_verified === true ?
                    <Navigate replace to={AUTH_SIGNUP_WITH_SHOP_LINK} />
                    :
                    <Platform />
                  :
                  <Navigate replace to={AUTH_LOGIN_LINK} />
              }></Route>
              <Route path="/email-verified" element={<Navigate replace to={DEFAULT_PLATFORM_LINK_BY_USER} />}></Route>
              <Route path="*" element={user ? <Navigate replace to={DEFAULT_PLATFORM_LINK_BY_USER} /> : <Navigate replace to={AUTH_LOGIN_LINK} />}></Route>
            </Routes>
          </PlatformLinksContext.Provider>
        </UserContext.Provider>
        : null}

    </div>
  );
}

export default App;
